// imove-branch: 是否已登录

export default async function(ctx) {
  const { data } = ctx.getPipe();
  return data === true;
}